module.exports = __webpack_public_path__ + "img/矩形 2580(2).e7d497ce.png";